import { FC } from 'react';
import { SeoBlock, PageContainer } from '@edikk-edikk/country-layout-black';
import { useHomeContext } from '#home/hooks';

const SeoTextLong: FC = () => {
  const { seo } = useHomeContext();

  if (!seo.textLong) {
    return null;
  }

  return (
    <PageContainer>
      <SeoBlock text={seo.textLong} categoryList={seo.categoryList} />
    </PageContainer>
  );
};

export { SeoTextLong };
